module.exports = __webpack_public_path__ + "static/media/material-list.3abd0c55.svg";